import Swiper from "swiper";
import { Pagination, Autoplay, EffectFade } from "swiper/modules";

export const initHeroBento = (): void => {
  const sliders = document.querySelectorAll<HTMLElement>(".hero-bento__swiper");

  if (sliders.length === 0) {
    return;
  }

  sliders.forEach((sliderElement) => {
    const slideCount = sliderElement.querySelectorAll(".swiper-slide").length;
    const enableLoop = slideCount > 1;

    // Isolate pagination inside this specific container
    const paginationEl = sliderElement.querySelector<HTMLElement>(
      ".hero-bento__pagination",
    );

    new Swiper(sliderElement, {
      modules: [Pagination, Autoplay, EffectFade],
      loop: enableLoop,
      effect: "fade",
      fadeEffect: {
        crossFade: true,
      },
      autoplay: {
        delay: 5000,
        disableOnInteraction: false,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
    });
  });

  console.log("[HeroBento] Isolated Swiper instances initialized.");
};
